import { Icon, MockKanban } from '@nexa/ui';
import { useCopy } from '@/core/i18n';

/**
 * Pane 1 của mock app — `template.html:717`. Bảng kanban 4 cột.
 *
 * Hai chỉ số dưới đây ĐO từ thiết kế, không phải quy ước: card đang làm là card đầu của cột
 * "đang làm" (cột 1, dòng 732 — nó có viền `brand-200` + bóng + avatar + chip HIGH), và cột
 * cuối là cột đã hoàn tất (dòng 741 — chữ mờ, gạch ngang).
 */
const IN_PROGRESS_COLUMN = 1;
const DONE_COLUMN = 3;

export function KanbanPane() {
  const kanban = useCopy().hero.mock.kanban;

  return (
    <div className="flex h-full flex-col">
      <div className="flex h-[54px] items-center gap-2.5 border-b border-ink-100 bg-surface px-[18px]">
        <Icon name="kanban" size={15} className="text-brand-600" />
        <span className="truncate text-body font-bold text-ink-mock-900">{kanban.title}</span>
        <span className="rounded-pill bg-brand-50 px-2.5 py-[3px] text-micro font-bold text-brand-600">
          {kanban.sprintBadge}
        </span>
        <span className="ml-auto hidden text-caption text-ink-600 sm:block">{kanban.deadline}</span>
      </div>

      <MockKanban
        density="hero"
        className="flex-1 p-4"
        columns={kanban.columns.map((column, columnIndex) => ({
          title: column.title,
          cards: column.cards.map((text, cardIndex) => {
            const isActive = columnIndex === IN_PROGRESS_COLUMN && cardIndex === 0;
            return {
              text,
              active: isActive,
              done: columnIndex === DONE_COLUMN,
              ...(isActive ? { assignee: kanban.assignee, priority: kanban.priority } : {}),
            };
          }),
        }))}
      />
    </div>
  );
}
